import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { cloneDeep, isEmpty, capitalize } from 'lodash';
import { Accordion, Card, Button, Row, Container } from 'react-bootstrap';
import moment from 'moment';
import { useDispatch, useSelector, batch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import DamListCard from '../../../../Components/Card/DamListCard/DamListCard';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { deleteProductDamFolderByIdAction, fetchDamProductFolders, filterDamFolderSortData } from './store/DamFolder.action';
import { fetchProductFolderOptionList } from '../DamFiles/store/DamFile.action';
import { useDamProductFolderModuleState } from './Provider/index';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import BtnSort from '../../ProductInformation/BtnSort';
import { Page_Size, damSortOpions } from '../../../../Components/helper';
import DamFolderFilter from './DamFolderFilter';
import { fetchDamFolderGroupList } from '../../../Library/DamFolder/store/DamFolder.action';
import DamFolderFilesFilter from './DamFolderFilesFilter';
import { fetchColorListLibrary } from '../../../Library/ColorLibary/store/ColorLibrary.action';
import {
  getBrandDetails,
  getCategory1Details,
  getCategory2Details,
  getDamAttributeFreeText,
  getPCTypesDetails,
} from '../../../SystemMasters/Store/SystemMasters.action';
import { getAllGradings } from '../../../Library/Pom/Store/Pom.action';

function DamFolder() {
  const ids = useLocation();
  const [searchQueries, setSearchQueries] = useState({});
  const history = useHistory();
  const devOrderId = ids.pathname.split('/')[2];
  const [selectedBomLibraryGroupId, setBomId] = useState(null);
  const [selectedFolderId, setFolderId] = useState('');
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { DamFolderstate, setDamFolderState, damAddEditAccess, damDeleteAccess } = useDamProductFolderModuleState([]);
  const [showFilterMobile, setFilterMobile] = useState(false);
  const [state, setState] = useState({
    damFolderList: [],
    hasMore: true,
    loading: true,
    totalRecords: null,
    searchText: '',
    searchLoaded: false,
    activeList: 'folder',
    isOpen: false,
    filterSort: null,
    searchFileLoaded: false,
  });
  const {
    damProductFolderModule: {
      filterValues: { pageIndex, pageSize, searchText },
      damProductFolderList,
      totalFolderCount,
    },
    UserDetails: {
      userInfo: { userId },
    },
    Measuremets: { productName },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (Array.isArray(damProductFolderList)) {
      setDamFolderState((prev) => ({ ...prev, damFolderList: damProductFolderList }));
    }
  }, [damProductFolderList]);

  useEffect(() => {
    if (totalFolderCount > damProductFolderList?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [damProductFolderList, totalFolderCount]);

  const buildParams = (data) => {
    const params = {
      pageIndex: data.pageIndex,
      pageSize: data.pageSize,
    };
    if (searchText) {
      params.searchText = searchText;
    }
    params.isScrolled = data.isScrolled;
    return params;
  };

  const getDamFolderGroupList = async (data, number) => {
    setState((toGetstate) => ({
      ...toGetstate,
      loading: true,
      ...data,
    }));

    const params = buildParams(data);
    if (devOrderId) {
      params.devOrderId = devOrderId;
    }
    await dispatch(fetchDamProductFolders(params));
    setState((inInfinitestate) => ({
      ...inInfinitestate,
      loading: false,
    }));
  };

  useEffect(() => {
    const callFn = async () => {
      setState((prev) => ({ ...prev, loading: true }));
      const localstorageFilter = JSON.parse(localStorage.getItem('damProductFolderListFilter'));
      const params = {
        pageIndex,
        pageSize,
        folder: localstorageFilter?.folder,
        fileType: localstorageFilter?.fileType,
      };
      if (devOrderId) {
        params.devOrderId = devOrderId;
      }
      await dispatch(fetchDamProductFolders(params));
      await dispatch(fetchDamFolderGroupList({ pageIndex, pageSize }));
      await dispatch(fetchProductFolderOptionList({ devOrderId }));
      setState((prev) => ({ ...prev, loading: false }));
    };
    callFn();
    return () => {
      const obj = {
        pageIndex: 1,
      };
      dispatch(filterDamFolderSortData(obj));
    };
  }, [dispatch]);

  useEffect(() => {
    const callFn = async () => {
      batch(async () => {
        if (userId) {
          await dispatch(
            fetchColorListLibrary({
              loggedInUserId: userId,
            }),
          );
          await dispatch(
            getPCTypesDetails({
              loggedInUserId: userId,
              isActive: true,
              tier: 'Tier1',
            }),
          );
          await dispatch(
            getBrandDetails({
              loggedInUserId: userId,
              isActive: 1,
            }),
          );
          await dispatch(
            getAllGradings({
              isDropdawn: true,
              loggedInUserId: userId,
            }),
          );
          await dispatch(
            getCategory1Details({
              categoryType: 1,
              loggedInUserId: userId,
              isActive: true,
            }),
          );
          await dispatch(
            getCategory2Details({
              categoryType: 2,
              loggedInUserId: userId,
              isActive: true,
            }),
          );
          await dispatch(getDamAttributeFreeText({ type: 'dropdown' }));
        }
      });
    };
    if (!isEmpty(userId)) callFn();
  }, [dispatch, userId]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      pageIndex: index,
      pageSize,
      searchText,
      totalRecords: totalFolderCount,
      isScrolled: true,
    };
    const obj = {
      pageIndex: index,
      pageSize,
    };
    await dispatch(filterDamFolderSortData(obj));

    if (devOrderId) {
      params.devOrderId = devOrderId;
    }

    await dispatch(fetchDamProductFolders(params));
  };

  const handleOpenProductIdentifier = async () => {
    setState((prevData) => ({
      ...prevData,
      isOpen: !state.isOpen,
    }));
  };

  const deleteDamFolderFilesGroup = (id, folderId) => {
    setBomId(id);
    setShowConfirmationPopup(!showConfirmationPopup);
    setFolderId(folderId);
  };

  const deleteById = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const params = {};
    if (selectedBomLibraryGroupId) {
      params.deletedIds = [selectedBomLibraryGroupId];
    } else {
      const allDeletedIdsOfSelectedFolder = [];
      const selectFolder = DamFolderstate?.damFolderList?.find((folder) => folder._id === selectedFolderId);
      selectFolder.productFiles.forEach((file) => {
        if (file.selected) {
          allDeletedIdsOfSelectedFolder.push(file._id);
        }
      });
      params.deletedIds = [...allDeletedIdsOfSelectedFolder];
    }
    if (devOrderId) {
      params.devOrderId = devOrderId;
    }
    if (selectedFolderId) {
      params.folderId = selectedFolderId;
    }
    const res = await dispatch(deleteProductDamFolderByIdAction(params, t));
    if (res) {
      setShowConfirmationPopup(!showConfirmationPopup);
      refreshPage();
    } else {
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const refreshPage = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
      pageIndex: 1,
      totalRecords: null,
      hasMore: true,
      searchText: '',
      searchLoaded: false,
    }));
    setDamFolderState((prev) => ({ ...prev, selectedIdArray: [], damFolderList: [] }));
    setBomId(null);
    setFolderId(null);
    const params = {
      pageIndex: 1,
      pageSize: state.pageSize || 20,
      damFolderList: [],
      totalRecords: null,
      isSelectAll: false,
      selectedIdArray: [],
    };
    if (devOrderId) {
      params.devOrderId = devOrderId;
    }
    await dispatch(fetchDamProductFolders(params));
    setState((prev) => ({
      ...prev,
      loading: false,
    }));
  };

  const getFullName = (obj) => {
    return `${obj?.firstName} ${obj?.lastName}`;
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((prev) => ({
      ...prev,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
      pageIndex: 1,
      pageSize: Page_Size,
      loading: true,
    };
    await dispatch(filterDamFolderSortData(obj));
  };

  const handleFileSearch = async (folderId, e) => {
    const targetValue = e.target.value;
    setSearchQueries({
      ...searchQueries,
      [folderId]: targetValue,
    });
  };

  const onOpenClick = async () => {
    history.push(`/development-order/${devOrderId}/digital-assets-management`, { activeList: 'open' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'open',
    }));

    const obj = {
      searchText: '',
    };
    await dispatch(filterDamFolderSortData(obj));

    const params = {
      pageIndex: 1,
      pageSize,
      damFolderList: [],
      totalRecords: state.totalRecords,
      searchText,
      isScrolled: false,
    };
    await getDamFolderGroupList(params);
  };

  const onFolderClick = async () => {
    history.push(`/development-order/${devOrderId}/digital-assets-management/folder`, { activeList: 'folder' });
    setState((prevData) => ({
      ...prevData,
      activeList: 'folder',
    }));

    const obj = {
      searchText: '',
    };
    await dispatch(filterDamFolderSortData(obj));

    const params = {
      pageIndex: 1,
      pageSize,
      isScrolled: false,
    };
    await getDamFolderGroupList(params);
  };

  const handleSortBy = async (val, folderId) => {
    setState((prevData) => ({
      ...prevData,
      filterSort: val
        ? {
            folderId,
            label: val?.label,
            value: {
              sortBy: val?.sortBy,
              sortOrder: val?.sortOrder,
            },
          }
        : null,
    }));

    const cloneFolderList = cloneDeep(damProductFolderList);
    const selectFolderData = cloneFolderList?.find((folder) => folder?._id === folderId);
    const selectedFolderFiles = selectFolderData?.productFiles;
    selectedFolderFiles.sort((a, b) => {
      let comparison = 0;

      // Sorting conditions based on val.sortBy
      if (val?.sortBy === 'size') {
        comparison = parseFloat(a.size) - parseFloat(b.size);
      } else if (val?.sortBy === 'assetTitle') {
        comparison = a.assetTitle.localeCompare(b.assetTitle);
      } else if (val?.sortBy === 'createdAt') {
        comparison = new Date(a.createdAt) - new Date(b.createdAt);
      } else if (val?.sortBy === 'updatedAt') {
        comparison = new Date(a.updatedAt) - new Date(b.updatedAt);
      }

      // Apply sortOrder (1 for ascending, -1 for descending)
      return val?.sortOrder === 1 ? comparison : -comparison;
    });

    const updateFolderData = cloneFolderList?.map((folder) => {
      if (folder?._id === folderId) {
        folder.productFiles = selectedFolderFiles;
        return folder;
      }
      return folder;
    });

    setDamFolderState((prev) => ({ ...prev, damFolderList: updateFolderData }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        const params = {
          pageIndex,
          pageSize,
          searchText,
        };
        const obj = {
          pageIndex: 1,
          pageSize: Page_Size,
          searchText,
        };
        await dispatch(filterDamFolderSortData(obj));
        if (devOrderId) {
          params.devOrderId = devOrderId;
        }
        await dispatch(fetchDamProductFolders(params));
        const afterApiCAllObj = {
          loading: false,
        };
        await dispatch(filterDamFolderSortData(afterApiCAllObj));
        setState((resetSearchstate) => ({
          ...resetSearchstate,
          searchLoaded: false,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const getFilteredFiles = (folder) => {
    const query = searchQueries[folder._id] || '';
    return folder?.productFiles?.filter((file) => file?.assetTitle?.toLowerCase().includes(query.toLowerCase()));
  };

  const deleteCard = (folderId) => {
    setFolderId(folderId);
    setShowConfirmationPopup(!showConfirmationPopup);
  };

  const handleFileCheckboxChange = (folderIndex, fileId) => {
    const updatedFolders = DamFolderstate?.damFolderList?.map((folder, fIndex) => {
      if (fIndex === folderIndex) {
        return {
          ...folder,
          productFiles: folder.productFiles.map((file) => (file._id === fileId ? { ...file, selected: !file.selected } : file)),
        };
      }
      return folder;
    });
    setDamFolderState((prev) => ({ ...prev, damFolderList: updatedFolders }));
  };

  const handleSelectAllNew = (folderIndex) => {
    const updatedFolders = DamFolderstate?.damFolderList?.map((folder, fIndex) => {
      if (fIndex === folderIndex) {
        const allSelected = folder.productFiles.every((file) => file.selected);
        return {
          ...folder,
          productFiles: folder.productFiles.map((file) => ({
            ...file,
            selected: !allSelected,
          })),
        };
      }
      return folder;
    });
    setDamFolderState((prev) => ({ ...prev, damFolderList: updatedFolders }));
  };

  const isAnyFileSelected = (folderIndex) => {
    return DamFolderstate?.damFolderList[folderIndex]?.productFiles.some((file) => file.selected);
  };

  return (
    <div>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <h4 className="title">{t('DAM_FOLDER_VIEW.LISTING_VIEW.DIGITAL_ASSET_FOLDER')} | &nbsp;</h4> {capitalize(productName?.number)}
        </div>
        <div className="search-filter">
          <SearchBar onSearch={handleSearch} value={searchText} placeholder={t('DAM_FOLDER_VIEW.LISTING_VIEW.SEARCH_PRODUCT_FOLDER')} />
          <div className="web-filter">
            <DamFolderFilter />
          </div>
          {damAddEditAccess && (
            <button type="button" onClick={() => setFilterMobile(!showFilterMobile)} className="filter-btn btn-mobile-more">
              <i className="icon-new-more" />
            </button>
          )}
        </div>
      </div>
      <Container fluid className="d-flex flex-wrap justify-content-end my-2">
        <button onClick={() => onOpenClick()} type="button" className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'open' && 'btn-active'}`}>
          {t('DAM_MAIN_VIEW.LISTING_VIEW.ASSETS')}
        </button>
        <button onClick={() => onFolderClick()} type="button" className={`btn my-1 my-md-0 btn-page-filter ${state?.activeList === 'folder' && 'btn-active'}`}>
          {t('DAM_MAIN_VIEW.LISTING_VIEW.FOLDERS')}
        </button>
      </Container>
      <InfiniteScroll
        dataLength={DamFolderstate?.damFolderList?.length}
        next={handlePageNextInScroll}
        hasMore={state?.hasMore}
        loader={state?.loading && <Loader />}
      >
        <div className="container-fluid my-3">
          {DamFolderstate?.damFolderList?.map((item, folderIndex) => {
            const itemSelected = item?.productFiles.filter((vl) => vl.selected);
            return (
              <Accordion defaultActiveKey="0" key={item._id}>
                <Card className="listing-card ">
                  <Card.Header>
                    <div className="header-container">
                      <div className="header-left">
                        <strong className="ml-2">{item?.name}</strong>
                      </div>
                      <div className="header-right">
                        {itemSelected?.length > 0 && (
                          <span className="d-none d-md-inline-block  f-14 mr-4 text-nowrap">
                            {itemSelected?.length}
                            {t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_SELECTED')}
                          </span>
                        )}
                        <SearchBar
                          onSearch={(e) => handleFileSearch(item?._id, e)}
                          value={searchQueries[item?._id] || ''}
                          placeholder={t('DAM_MAIN_VIEW.LISTING_VIEW.SEARCH_PRODUCT_DAM')}
                        />

                        <BtnSort
                          options={damSortOpions}
                          onBtnClick={(val) => handleSortBy(val, item?._id)}
                          val={state?.filterSort?.folderId === item?._id ? state.filterSort : null}
                        />
                        <DamFolderFilesFilter folderId={item?._id} />

                        {damDeleteAccess && (
                          <button
                            onClick={() => deleteCard(item?._id)}
                            disabled={!isAnyFileSelected(folderIndex)}
                            className="filter-btn filter-button_delete"
                            title={t('DAM_MAIN_VIEW.LISTING_VIEW.UNLINK')}
                            type="button"
                          >
                            <i className="icon-new-unlink f-14" />
                            <span className="text-icon">{t('BTN_CLOCK.INSTANT_REQUEST')}</span>
                          </button>
                        )}

                        {damAddEditAccess && (
                          <button
                            onClick={() => handleSelectAllNew(folderIndex)}
                            disabled={item?.productFiles?.length <= 0}
                            type={t('BTN_FILTER.BUTTON')}
                            className="filter-btn filter-button_selectall"
                          >
                            <i className="icon-check" />
                            {item?.productFiles?.every((file) => file?.selected) ? 'Unselect All' : 'Select All'}
                          </button>
                        )}

                        <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval placement-top">
                          <span className="icon-info" />
                          <div className="info-content text-nowrap">
                            <p className="text-right m-0">
                              <strong>{t('CUSTOM_MODULE.CREATED')} </strong> :{' '}
                              {`${typeof item?.createdBy === 'object' ? getFullName(item?.createdBy) : item?.createdBy} ${
                                item?.createdAt && moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm')
                              }`}
                            </p>

                            <p className="text-right m-0">
                              <strong>{t('CUSTOM_MODULE.MODIFIED')} </strong> :{' '}
                              {`${typeof item?.modifiedBy === 'object' ? getFullName(item?.modifiedBy) : item?.modifiedBy} ${
                                item?.updatedAt && moment(item?.updatedAt).format('DD-MMMM-YYYY, HH:mm')
                              }`}
                            </p>
                          </div>
                        </div>
                        <Accordion.Toggle
                          className="text-decoration-none btn-toggle"
                          onClick={() => handleOpenProductIdentifier()}
                          as={Button}
                          variant="link"
                          eventKey="0"
                        >
                          <i className="icon-new-down-arrow-icon icon-inverse top-padding" />
                        </Accordion.Toggle>
                      </div>
                    </div>
                  </Card.Header>

                  <Accordion.Collapse eventKey="0">
                    <Card.Body className="py-3">
                      <Row>
                        {getFilteredFiles(item)?.length > 0 ? (
                          getFilteredFiles(item)?.map((fileItem, i) => (
                            <DamListCard
                              key={fileItem?._id}
                              item={fileItem}
                              index={i}
                              onDelete={() => {}}
                              onUnlink={deleteDamFolderFilesGroup}
                              onCheck={() => {}}
                              selectedIds={[]}
                              t={t}
                              damDeleteAccess={damDeleteAccess}
                              damAddEditAccess={damAddEditAccess}
                              isFolderProductLevel
                              folderId={item._id}
                              folderIndex={folderIndex}
                              handleFileCheckboxChange={handleFileCheckboxChange}
                            />
                          ))
                        ) : (
                          <div className="container-fluid my-3">
                            <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>
                          </div>
                        )}
                      </Row>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            );
          })}
          {DamFolderstate?.damFolderList?.length === 0 && !state?.loading && <p className="text-center">{t('TAKING_DATES.NO_DATA_FOUND')}</p>}
        </div>
      </InfiniteScroll>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          message={t('DAM_MAIN_VIEW.LISTING_VIEW.DAM_UNLINK_GROUP')}
          title="Unlink"
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
        />
      )}
    </div>
  );
}

export default DamFolder;
